module.exports = __webpack_public_path__ + "img/cached-logo-green-icon.e4d7bca2.svg";